<template>
    <div class="login">
        <div class="content">
            <van-field
                v-model="phone"
                clearable
                label-width= 90
                label="手机号码"
                placeholder="请输入手机号"
                size="medium"
                class="inputVant"
            />
            <van-field
                v-model="verification"
                label-width= 90
                size="medium"
                class="inputVant"
                center
                clearable
                label="短信验证码"
                placeholder="请输入短信验证码"
            >
                <van-button slot="button" size="medium" v-show="show" @click="getdata()" type="primary">发送验证码</van-button>
                <div  class="btnInfo"  v-show="!show" slot="button">{{count}}</div>
                
            </van-field>

            <div class="boreder"></div>
        </div>
        <div class="btn" @click="Submission()">完 成</div>
    </div>
</template>
<script>
import { Field, Button, Notify } from 'vant';
import { sendSms } from '@/api/index';
export default {
    components:{
        [Field.name] : Field,
        [Button.name] : Button,
        [Notify.name] : Notify,
    },
    data(){
        return {
            phone: '',
            verification: '',
            show: true,
            count: '',
            timer: null,
            codes: 0
        }
    },
    methods:{
        getdata(){
            this.show = false;
            this.getCode();
            if(this.phone === '') {
                Notify({message: '手机号格式不正确',duration: 1000,background: '#F54032'});
            }
            sendSms({phone: this.phone, dataType: 0}).then(res=>{
                this.codes = res.data;
            }).catch(error=>{

            })
        },
           getCode(){
            const TIME_COUNT = 60;
            if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
                console.log(this.count);
                this.count--;
                } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
                }
            }, 1000)
            }
        },
        Submission(){
            if (this.verification == '' ){
                Notify({message: '验证码不能为空',duration: 1000,background: '#F54032'});
            }else if(this.verification == this.codes){
                this.$loca.setItem('phone', this.phone );
                this.$router.push({path: '/'})
            }else {
                Notify({message: '验证码输入错误',duration: 1000,background: '#F54032'});
            }
        }  
    }
}
</script>
<style lang="scss" scoped>
.login{
    width: 100vw;
    height: 100%;
    // background: #f6f6f6;
    .content{
        // border-bottom: 1px solid #ebedf0;
        .inputVant{
            line-height: 71px;
            align-items:center;
            position: relative;
            .btnInfo{
               position: absolute;
               right: 0;
               top: 0;
            
            }
        }
    }
    .btn{
        margin:0 auto;
        margin-top: 20%;
        width:616px;
        height:88px;
        background:rgba(0,183,238,1);
        border-radius:10px;
        color: #ffffff;
        font-size: 40px;
        line-height: 88px;
        text-align: center;
    }
}
</style>

